import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {AuthGuard} from './shared/services/auth.guard';


@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home'
      },
      {
        path: 'home',
        loadChildren: () => import('./features/home-page/home-page.module').then(m => m.HomePageModule)
      },
      {
        path: 'about-us',
        loadChildren: () => import('./features/about-us/about-us.module').then(m => m.AboutUsModule)
      },
      {
        path: 'contact',
        loadChildren: () => import('./features/contact/contact.module').then(m => m.ContactModule)
      },
      {
        path: 'login',
        loadChildren: () => import('./features/login-page/login-page.module').then(m => m.LoginPageModule)
      },
      {
        path: 'create-account',
        loadChildren: () => import('./features/create-account/create-account.module').then(m => m.CreateAccountModule)
      },
      {
        path: 'password',
        loadChildren: () => import('./features/password-reset/password-reset.module').then(m => m.PasswordResetModule)
      },
      {
        path: 'error',
        loadChildren: () => import('./features/error-page/error-page.module').then(m => m.ErrorPageModule)
      },
      {
        path: 'finalization',
        loadChildren: () => import('./features/finalization-page/finalization-page.module').then(m => m.FinalizationPageModule)
      },
      {
        path: 'why-quickform',
        loadChildren: () => import('./features/why-quickform/why-quickform.module').then(m => m.WhyQuickformModule)
      },
      {
        path: 'find-job',
        loadChildren: () => import('./features/find-job-page/find-job.module').then(m => m.FindJobModule)
      },
      {
        path: 'control-panel',
        loadChildren: () => import('./features/control-panel/control-panel.module').then(m => m.ControlPanelModule)
      },
      {
        path: 'discrimination',
        loadChildren: () => import('./features/discrimination-page/discrimination-page.module').then(m => m.DiscriminationPageModule)
      },
      {
        path: 'compare-other-methods',
        loadChildren: () => import('./features/compare-other-methods/compare-methods.module').then(m => m.CompareMethodsModule)
      },
      {
        path: 'recruit',
        loadChildren: () => import('./features/recruit-page/recruit-page.module').then(m => m.RecruitPageModule)
      },
      {
        path: 'checkout',
        loadChildren: () => import('./features/checkout/checkout.module').then(m => m.CheckoutModule)
      },
      {
        path: 'job-ad-detail',
        loadChildren: () => import('./features/job-ad-detail/job-ad-detail.module').then(m => m.JobAdDetailModule)
      },
      {
        path: 'my-account',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/my-account/my-account.module').then(m => m.MyAccountModule)
      },
      {
        path: 'super-administrator',
        canActivate: [AuthGuard],
        loadChildren: () => import('./features/super-administrator/super-administrator.module').then(m => m.SuperAdministratorModule)
      },
      {
        path: '**',
        redirectTo: 'home',
      }
    ],  {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})

export class AppRoutingModule { }
